import * as React from "react";
const InternetIcon = (props) => (
  <svg
    fill={props?.fill}
    height={26}
    width={26}
    version="1.1"
    id="Capa_1"
    viewBox="0 0 490 490"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <path d="M445.06,154.352C410.115,77.368,333.233,26.827,248.63,25.425c-87.761-1.454-167.512,49.093-203.714,128.93 C19.6,157.729,0,179.451,0,205.675v78.647c0,26.227,19.604,47.95,44.924,51.321C80.517,414.166,158.449,464.605,245,464.605 c86.558,0,164.489-50.435,200.077-128.963c25.319-3.371,44.923-25.094,44.923-51.32v-78.647 C490,179.443,470.387,157.716,445.06,154.352z M248.32,44.113c74.364,1.232,142.218,43.957,175.786,109.772H65.871 C100.599,85.593,171.068,42.833,248.32,44.113z M245,445.915c-76.138,0-144.986-42.66-179.12-109.803h358.24 C389.989,403.255,321.144,445.915,245,445.915z M471.31,284.322c0,18.252-14.848,33.1-33.1,33.1H51.79 c-18.252,0-33.1-14.848-33.1-33.1v-78.647c0-18.252,14.848-33.1,33.1-33.1h386.42c18.252,0,33.1,14.848,33.1,33.1V284.322z"></path>
        <polygon points="135.931,258.049 120.134,209.152 98.323,209.152 82.526,258.049 66.729,209.152 43.403,209.152 70.936,290.094 94.252,290.094 109.302,246.011 124.195,290.094 147.667,290.094 175.2,209.152 151.728,209.152 "></polygon>
        <polygon points="271.634,258.049 255.837,209.152 234.026,209.152 218.228,258.049 202.432,209.152 179.106,209.152 206.639,290.094 229.955,290.094 245.005,246.011 259.898,290.094 283.369,290.094 310.903,209.152 287.431,209.152 "></polygon>
        <polygon points="407.337,258.049 391.539,209.152 369.729,209.152 353.931,258.049 338.135,209.152 314.809,209.152 342.342,290.094 365.658,290.094 380.708,246.011 395.601,290.094 419.072,290.094 446.605,209.152 423.134,209.152 "></polygon>
      </g>
    </g>
  </svg>
);
export default InternetIcon;
